import React from 'react';
import 'fontsource-roboto';
import Box from '@material-ui/core/Box';
import Iframe from 'react-iframe'
import Button from '@material-ui/core/Button';

export default function StepTiles(props) {
  const handleStepComplete = (value) => () => {
    props.onChange(value);
  };

  return (
    <Box>
      <Iframe url={props.step.options.url}
        width={props.step.options.width}
        height={props.step.options.height}
      />
      <Box style={{float: 'right', marginTop: '8px'}}>
        {props.step.buttons.map(button =>
          <Button key={button.value} variant={button.variant} color={button.color} style={{marginLeft: '8px'}}
            onClick={handleStepComplete(button.value)}
          >
            {button.label}
          </Button>
        )}
      </Box>
    </Box>
  );
}